/**
 * A map location.
 */
export interface Location {
    /**
     * The unique id of the location.
     */
    id: string;
    /**
     * The location's short display name to show in the progress indicator title.
     */
    titleDisplayName: string;
    /**
     * The location's long display name to show in the progress indicator tooltip.
     */
    tooltipDisplayName: string;
    /**
     * A callback function to navigate to the location.
     */
    openItem: () => void;
}

/**
 * Map location type.
 */
export enum LocationType {
    /**
     * Dls location type.
     */
    Dls,
    /**
     * Nts location type.
     */
    Nts
}

/**
 * Data describing a location on a map.
 */
export interface LocationData extends Location {
    /**
     * Location type ("dls" or "nts").
     */
    type: LocationType;
}

/**
 * Map error level.
 */
export enum ErrorLevel {
    /**
     * Error level for errors.
     */
    Error,
    /**
     * Error level for warnings.
     */
    Warning
}

/**
 * A location which is unmappable by the mapping library.
 */
export interface UnmappableLocation extends Location {
    /**
     * The error level for the location ("warning" or "error").
     */
    errorLevel: ErrorLevel;
    /**
     * The message detailing why the location is unmappable.
     */
    message: string;
}



// WEBPACK FOOTER //
// api.ts